export default {
  ruleToDefinition(rule) {
    let ruleDefinition = {};

    if (rule.dimension === 'progressHistory' || rule.dimension === 'clickHistory' || rule.dimension === 'engageHistory') {

      ruleDefinition.$eq = rule[rule.dimension];

      if (rule.comparison === '$in') {
        ruleDefinition.$in_last_days = parseInt(rule.inLastDays, 10);
      } else if (rule.comparison === '$nin') {
        ruleDefinition.$nin_last_days = parseInt(rule.inLastDays, 10);
      } else if (rule.comparison === '$lt') {
        ruleDefinition.$lt = parseInt(rule.inLastDays, 10);
      }
    } else {
      ruleDefinition[rule.comparison] = rule[rule.dimension];

      if (/in_last_days$/.test(rule.comparison) || (rule.dimension === 'lastSession' && /lt/.test(rule.comparison))) {
        ruleDefinition[rule.comparison] = parseInt(rule.inLastDays, 10);
      } else if (rule.inLastDays) {
        ruleDefinition.$in_last_days = parseInt(rule.inLastDays, 10);
      }
    }

    return {[rule.dimension]: ruleDefinition};
  },
  ruleDefinitionToRule(ruleDefinition, logical){
    let rule = {};
    let dimension = Object.keys(ruleDefinition)[0];

    if (ruleDefinition.matchingSegment) {
      let comparison = Object.keys(ruleDefinition[dimension])[0];
      let value = ruleDefinition[dimension][comparison];
      rule = {
        logical: logical,
        comparison: comparison,
        dimension: dimension,
        [dimension]: value
      };
    } else if (ruleDefinition.progressHistory || ruleDefinition.clickHistory  || ruleDefinition.engageHistory) {
      let comparison = ruleDefinition[dimension].$in_last_days ? '$in' : '$nin';
      let inLastDays =
          ruleDefinition[dimension].$in_last_days ||
          ruleDefinition[dimension].$nin_last_days;
      let value = ruleDefinition[dimension].$eq;
      rule = {
        logical,
        comparison,
        dimension: dimension,
        [dimension]: value,
        inLastDays
      };
    } else {
      let comparison = Object.keys(ruleDefinition[dimension])[0];
      let value = ruleDefinition[dimension][comparison];
      let inLastDays = ruleDefinition[dimension].$in_last_days;
      rule = {
        logical: logical,
        comparison: comparison,
        dimension: dimension,
        [dimension]: value
      };

      if (ruleDefinition[dimension].$in_last_days && (ruleDefinition[dimension].$gte || ruleDefinition[dimension].$gt || ruleDefinition[dimension].$lte || ruleDefinition[dimension].$lt)) {
        rule.inLastDays = ruleDefinition[dimension].$in_last_days;
      } else if (/in_last_days$/.test(comparison) || (dimension === 'lastSession' && /lt/.test(comparison))) {
        rule.inLastDays = ruleDefinition[dimension][comparison];
        delete rule[dimension];
      } else if (inLastDays) {
        rule.inLastDays = inLastDays;
      }
    }

    return rule;
  },
  definitionToRules(definition={}){
    let rules = [];
    _.intersection(Object.keys(definition),['$and','$or']).forEach((logical) => {
      (definition[logical]||[]).forEach((ruleDefinition) => {
        rules.push(this.ruleDefinitionToRule(ruleDefinition, logical));
      });
    });

    return rules;
  },
  toDefinition(rules=[]) {
    let res = {
      $and: [],
      $or: [],
    };

    let rulesCloneForOperatorsCount = _.cloneDeep(rules);
    rulesCloneForOperatorsCount.shift(); // when it comes to check the logical operators, the first rule is unnecessary.

    const foundOr = _.find(rulesCloneForOperatorsCount, (rule) => { return rule.logical === '$or'; });
    const foundAnd = _.find(rulesCloneForOperatorsCount, (rule) => { return rule.logical === '$and'; });
    const foundGroupedOr = _.find(rulesCloneForOperatorsCount, (rule) => { return rule.logical === '$grouped_or'; });
    const foundGroupedAnd = _.find(rulesCloneForOperatorsCount, (rule) => { return rule.logical === '$grouped_and'; });

    if (foundOr && foundGroupedOr || foundAnd && foundGroupedAnd) {
      return {};
    } else if ((foundOr && !foundGroupedOr && !foundAnd && !foundGroupedAnd) || (!foundOr && foundGroupedOr && !foundAnd && !foundGroupedAnd)) {
      // all ors
      res.$or = res.$or || [];
      const rulesConvertetToDefinition = rules.map(this.ruleToDefinition);
      rulesConvertetToDefinition.forEach((ruleDefinition) => res.$or.push({$and: [ruleDefinition]}));
      res.$and = res.$and || [];
    } else if (rules.length == 1 || (!foundOr && !foundGroupedOr && foundAnd && !foundGroupedAnd) || (!foundOr && !foundGroupedOr && !foundAnd && foundGroupedAnd)) {
      // all ands
      rules.forEach((rule) => {
        res.$and.push(this.ruleToDefinition(rule));
      });
    } else if ((foundOr && !foundGroupedOr && !foundAnd && foundGroupedAnd)) {
      // (A GROUPED_AND B) OR (C GROUPED_AND D)
      this.createRulesGroups(rules).forEach((rulesGroup) => {
        const rulesConvertetToDefinition = rulesGroup.map(this.ruleToDefinition);
        res.$or.push({$and: []});
        rulesConvertetToDefinition.forEach((ruleDefinition) => res.$or[res.$or.length - 1].$and.push(ruleDefinition));
      });
    } else if ((!foundOr && foundGroupedOr && foundAnd && !foundGroupedAnd)) {
      // (A GROUPED_OR B) AND C
      if (this.isThereOnlyOneGroupedOrBlock(rules)) {
        this.createRulesGroups(rules).forEach((rulesGroup) => {
          const rulesConvertetToDefinition = rulesGroup.map(this.ruleToDefinition);
          if (rulesGroup.length === 1) {
            res.$and.push(rulesConvertetToDefinition[0]);
          } else {
            rulesConvertetToDefinition.forEach((ruleDefinition) => res.$or.push({$and: [ruleDefinition]}));
          }
        });
      }
    }
    return res;
  },
  toRules(definition={}) {
    let rules = [];
    if (_.isEmpty(definition.$or) && _.isEmpty(definition.$and)) {
      // empty definition
    } else if (_.isEmpty(definition.$or) && !_.isEmpty(definition.$and)) {
      // all A AND B AND C
      rules = definition.$and.map((ruleDefinition) => {
        return this.ruleDefinitionToRule(ruleDefinition, '$and');
      });
    } else if (!_.isEmpty(definition.$or) && _.isEmpty(definition.$and)) {
      // could be === A OR B OR C || (A AND B) OR (C AND D AND E)
      const areGroupedRules = !!_.find(definition.$or, (singleOr) => { return singleOr.$and && singleOr.$and.length > 1; });
      if(areGroupedRules) {
        definition.$or.forEach((objectContainingAndArray) => {
          if(objectContainingAndArray.$and.length > 1) {
            objectContainingAndArray.$and.forEach((singleRuleDefinition, indexInside$andArray) => {
              rules.push(this.ruleDefinitionToRule(singleRuleDefinition, indexInside$andArray === 0 ? '$or' : '$grouped_and'));
            });
          } else {
            rules.push(this.ruleDefinitionToRule(objectContainingAndArray.$and[0], '$or'));
          }
        });
      } else {
        rules = definition.$or.map((ruleDefinitionContainer) => {
          return this.ruleDefinitionToRule(ruleDefinitionContainer.$and[0], '$or');
        });
      }
    } else if (!_.isEmpty(definition.$or) && !_.isEmpty(definition.$and)) {
      // A AND B AND (C OR D):
      // - rules contained in $and are groups composed of a single rule = A, B
      // - rules contained in $or are the (only one allowed) group of rule = C grouped_or D
      definition.$or.forEach((ruleDefinitionContainer) => {
        rules.push(this.ruleDefinitionToRule(ruleDefinitionContainer.$and[0], '$grouped_or'));
      });
      definition.$and.forEach((singleRuleDefinition) => {
        rules.push(this.ruleDefinitionToRule(singleRuleDefinition, '$and'));
      });
    }

    if (rules.length) {
      // convention -> the first logical is actually disregarded but it's always set to $and
      rules[0].logical = '$and';
    }
    return rules;
  },
  isThereOnlyOneGroupedOrBlock(rules) {
    // check that only a single $grouper_or block exists
    let indexOfLastGroupedOr = -1;
    let hasOnlyOneGroupedOrBlock = true;
    rules.forEach((rule, index) => {
      if (!hasOnlyOneGroupedOrBlock) {
        return;
      }
      if (rule.logical === '$grouped_or') {
        if (indexOfLastGroupedOr > -1 && index - 1 > indexOfLastGroupedOr) {
          hasOnlyOneGroupedOrBlock = false;
        }
        indexOfLastGroupedOr = index;
      }
    });
    return hasOnlyOneGroupedOrBlock;
  },
  ruleToString(rule, isFirst, translate) {
    let result = [];

    if (isFirst)
      result.push(rule.logical.replace(/\$/g,''));

    result.push(rule.dimension);

    if (rule.dimension === 'progressHistory' || rule.dimension === 'clickHistory' || rule.dimension === 'engageHistory') {
      result.push(`equal "${rule[rule.dimension]}"`);
      if (rule.comparison === '$in') {
        result.push(`in last ${rule.inLastDays} days`);
      } else if (rule.comparison === '$nin') {
        result.push(`not in last ${rule.inLastDays} days`);
      }
    } else if (rule.comparison == '$exists') {
      result.push(rule[rule.dimension] ? 'exists' : 'not exists');
    } else if (rule.dimension == 'countryCode') {
      result.push(JSON.stringify(
        rule[rule.dimension].map((countryCode) => translate(`countryCodes.${countryCode}`))
      ));
    } else if (!/in_last_days$/.test(rule.comparison) && !/lt$/.test(rule.comparison)) {
      result.push(rule.comparison.replace(/\$/g,''));
      result.push(JSON.stringify(rule[rule.dimension]));
      if (rule.inLastDays)
        result.push(`in last ${rule.inLastDays} days`);
    } else {
      if (rule.inLastDays) {
        if (['$gte', '$gt', '$lte', '$lt'].includes(rule.comparison)) {
          result.push(rule.comparison.replace(/\$/g,''));
          result.push(JSON.stringify(rule[rule.dimension]));
          if (rule.inLastDays) {
            result.push(`in last ${rule.inLastDays} days`);
          }
        } else {
          if (rule.comparison == '$in_last_days') {
            result.push(`in last ${rule.inLastDays} days`);
          }
          if (rule.comparison == '$nin_last_days') {
            result.push(`not in last ${rule.inLastDays} days`);
          }
        }
      }
    }

    (rule.children||[]).forEach((rule) => {
      result = result.concat(
        this.ruleToString(_.merge({},rule,{logical: '$or'}), true)
      );
    });

    return result;
  },
  toString(definition={},translate) {
    let rules = this.toRules(definition);
    let result = [];

    rules.forEach((rule,index) => {
      result = result.concat(this.ruleToString(rule, index > 0, translate));
    });

    return _.upperFirst(result.join(' '));
  },
  hasGroupedLogicalOperator(rule) {
    return (rule.logical === '$grouped_and' || rule.logical === '$grouped_or');
  },
  // createRulesGroups() returns an array of arrays []
  createRulesGroups(rules) {
    let rulesGroups = [];
    rules.forEach((rule) => {
      if (this.hasGroupedLogicalOperator(rule)) {
        if (rulesGroups.length === 0) {
          rulesGroups.push([]);
        }
        rulesGroups[rulesGroups.length - 1].push(rule);
      } else {
        rulesGroups.push([rule]);
      }
    });
    return rulesGroups;
  },
  hasMultipleGROUPED_ORBlocks(rules) {
    if (!rules || !rules.length) {
      return false;
    }

    let clonedRules = _.cloneDeep(rules);

    const foundGroupedOr = _.find(clonedRules, (rule) => { return rule.logical === '$grouped_or'; });
    const arrayOfArraysOfRules = this.createRulesGroups(clonedRules);
    let countOfGroupsWithMoreThanOneRule = 0;

    if(arrayOfArraysOfRules.length) {
      arrayOfArraysOfRules.forEach((arrayOfRules) => {
        if (arrayOfRules.length > 1) {
          countOfGroupsWithMoreThanOneRule++;
        }
      });
    }

    return (countOfGroupsWithMoreThanOneRule  > 1) && !!foundGroupedOr;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/segments/segmentsRulesTransform.js
 **/